import { GameContextObject } from 'Model';
import React from 'react';

const GameContext = React.createContext<GameContextObject>({});

export { GameContext };
